module.exports = __webpack_public_path__ + "static/media/notification.6cc5c562.svg";